import {ExternalApiSummary} from "../../../../model/ExternalApiSummary";
import {Dial} from "../../../../raal_components/dial/Dial";
import {RouteComponentProps} from "../../../../routes";
import {useTranslation} from "react-i18next";
import * as React from "react";
import {FormInputType} from "../../../../raal_components/form/Form";
import {FormDateRange} from "../../../../../common/component/form/FormDateRange";

export function ExternalApiSummaryDial(props: RouteComponentProps) : JSX.Element {
    const {t} = useTranslation();
    return <Dial<ExternalApiSummary>
        mode={props.mode}
        config={{
            tableTitle: t("Dials.ExternalApiSummary"),
            endpoint: "admin/external-api-summary",
            clazz: ExternalApiSummary,
            filtering: true,
            hideAddNewActions: true,
            disableRowClick: true,
            defaultSorting: ['date', 'desc'],
            columns: [
                {
                    title: t("ExternalApiSummary.slug"),
                    field: 'slug',
                    filterProps:() => ({type:FormInputType.Text}),
                },
                {
                    title: t("ExternalApiSummary.date"),
                    field: 'date',
                    filterProps:() => ({type: FormInputType.Custom, customComponent:FormDateRange, customComponentOptions:{timeFormat: false}}),
                },
                {
                    title: t("ExternalApiSummary.created"),
                    field: 'created',
                },
                {
                    title: t("ExternalApiSummary.updated"),
                    field: 'updated',
                },
                {
                    title: t("ExternalApiSummary.deleted"),
                    field: 'deleted',
                }
            ]
        }}
        crudConfig={{editEnabled: false, removeEnabled: false, addEnabled: false}}
        createInstance={() => new ExternalApiSummary()}
    ></Dial>
}